import request from '@/utils/request'
//根据businessCode数组获取文件列表
export function getFileList(url,businessCodeAry) {
  return request({
    url: url+'/fileUpload/getFileList',
    method: 'post',
    data:businessCodeAry
  })
}
//删除文件
export function deleteFiles(url,businessCodeAry) {
  return request({
    url: url+'/fileUpload/deleteFiles',
    method: 'post',
    data:businessCodeAry
  })
}

//删除文件
export function deleteFile(url,id) {
  return request({
    url: url+'/fileUpload/deleteFile/'+id,
    method: 'get',
  })
}

// 获取上传文件的百度云文件夹名称
export function uploadFileBosGetPrefix(url,fileName){
  return request({
    url: url+'/fileUpload/getPrefix/'+fileName,
    method: 'get',
  })
}

// 百度云上传完毕后调用此接口对接业务
export function uploadFileBos(url,data){
  return request({
    url: url+'/fileUpload/saveUploadFile',
    method: 'post',
    data:data
  })
}

// 学校账号个人中心批量上传作品
export function uploadFileSchool(url, data){
  return request({
    url: url+'/fileUpload/batchSaveUploadFiles',
    method: 'post',
    data:data
  })
}



// WEBPACK FOOTER //
// ./src/api/system/file.js